// @ts-nocheck
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { AvailabilityDto } from "@insite/client-framework/Types/ApiModels";
import RelatedProductsButton, { RelatedProductsButtonStyles } from "@store/Library/Components/RelatedProductsButton";
import storeConstants from "@store/storeConstants";
import React, { MutableRefObject, useEffect, useState } from "react";

interface OwnProps {
    extendedStyles?: RelatedProductsButtonStyles;
    productId?: string;
    partNumber?: string;
    showAsLink?: boolean;
    availability?: AvailabilityDto;
    displayEvenWithoutProducts?: boolean;
    useQuickOrderUxBehavior?: boolean;
    dynamicDropdownRef?: MutableRefObject<HTMLDivElement | null>;
}

type Props = OwnProps & HasProductContext;

const SimilarProductsButton = ({
    productId,
    productContext,
    partNumber,
    extendedStyles,
    showAsLink,
    availability,
    displayEvenWithoutProducts,
    useQuickOrderUxBehavior,
    dynamicDropdownRef,
}: Props) => {
    const [isInStock, setIsInStock] = useState(false);
    const [availabilityStatus, setAvailabilityStatus] = useState("");
    const [modalHeader, setModalHeader] = useState("");
    const [inventoryAvailability, setInventoryAvailability] = useState<AvailabilityDto | undefined>(undefined);
    const [hasProducts, setHasProducts] = useState(true);

    useEffect(() => {
        if (availability) {
            setInventoryAvailability(availability);
        }
    }, [availability]);

    useEffect(() => {
        if (inventoryAvailability) {
            if (inventoryAvailability?.availabilityCode) {
                setAvailabilityStatus(inventoryAvailability?.availabilityCode);
                setIsInStock(inventoryAvailability?.availabilityCode === storeConstants.availabilityCodes.InStock);
            }
        }
    }, [inventoryAvailability]);

    useEffect(() => {
        if (productContext) {
            let tmpModalHeader;
            const { productInfo, product } = productContext;
            if (productInfo) {
                const { unitOfMeasure, inventory, failedToLoadInventory } = productInfo;

                if (inventory) {
                    const availability =
                        inventory?.inventoryAvailabilityDtos?.find(
                            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
                        )?.availability || undefined;

                    setInventoryAvailability(availability);
                }
                if (failedToLoadInventory) {
                    setIsInStock(false);
                }
            }
            if (product) {
                const relationShipsProperties = product.properties.relationships;
                const relationShips = relationShipsProperties ? JSON.parse(relationShipsProperties) : undefined;
                if (relationShips) {
                    setHasProducts(relationShips?.[storeConstants.productRelation.SimilarProduct]?.hasProducts);
                } else {
                    setHasProducts(false);
                }
            }
            if (availabilityStatus && availabilityStatus === storeConstants.availabilityCodes.Discontinued) {
                tmpModalHeader =
                    partNumber || productContext.product.productNumber
                        ? translate(
                              "The product {0} is discontinued. Please select a similar item.",
                              partNumber || productContext.product.productNumber,
                          )
                        : translate("This product is discontinued. Please select a similar item.");
                setModalHeader(tmpModalHeader);
            } else if (
                availabilityStatus &&
                (availabilityStatus === storeConstants.availabilityCodes.OutOfStock ||
                    availabilityStatus === storeConstants.availabilityCodes.OnDemand)
            ) {
                tmpModalHeader =
                    partNumber || productContext.product.productNumber
                        ? translate(
                              "The product {0} is not in stock at the moment. Here are some similar products.",
                              partNumber || productContext.product.productNumber,
                          )
                        : translate("This product is not in stock at the moment. Here are some similar products.");
                setModalHeader(tmpModalHeader);
            }
        }
    }, [availabilityStatus, productContext]);

    if (!availabilityStatus || isInStock || (!hasProducts && !displayEvenWithoutProducts)) {
        return null;
    }

    return (
        <RelatedProductsButton
            modalHeader={modalHeader}
            label={translate("See Similar Products")}
            emptyMessage={translate("There are no similar products.")}
            productRelation={storeConstants.productRelation.SimilarProduct}
            productId={productId!}
            extendedStyles={extendedStyles}
            showAsLink={showAsLink}
            useQuickOrderUxBehavior={useQuickOrderUxBehavior}
            dynamicDropdownRef={dynamicDropdownRef}
        />
    );
};

export default withProductContext(SimilarProductsButton);
